import { render, staticRenderFns } from "./PageEditor.vue?vue&type=template&id=00465327&scoped=true&"
import script from "./PageEditor.vue?vue&type=script&lang=ts&"
export * from "./PageEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00465327",
  null
  
)

export default component.exports